import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material/styles';
import ContentSwitch from '../../../ContentSwitch/ContentSwitch.js';

const _ContentSwitch = styled(ContentSwitch, { shouldForwardProp: prop => prop !== 'rtl' }) `
  ${({ rtl }) => `
    margin-left: ${rtl ? '16px' : '0'};
    margin-right: ${rtl ? '0' : '16px'};
  `}
`;
const ContentSwitchButtons = (_a) => {
    var { contentSwitchOptions, onContentSwitchSelectionChange } = _a, rest = __rest(_a, ["contentSwitchOptions", "onContentSwitchSelectionChange"]);
    if (!contentSwitchOptions) {
        return null;
    }
    return (jsx(_ContentSwitch, Object.assign({ onSelectionChange: onContentSwitchSelectionChange, options: contentSwitchOptions, hideCounter: true }, rest)));
};

export { ContentSwitchButtons as default };
//# sourceMappingURL=ContentSwitchButtons.js.map
